import { action } from 'typesafe-actions'
import { types } from './types'

export const updateFormData = (payload: any) =>
  action(types.UPDATE_FORMDATA, payload)
export const videosDialog = () => action(types.OPEN_VIDEO)
export const tagsDialog = () => action(types.OPEN_TAG)
export const personsDialog = () => action(types.OPEN_PERSON)
export const attachmentsDialog = () => action(types.OPEN_ATTACHMENTS)
export const commentsTitileDialog = () => action(types.OPEN_COMMENTQUESTION)
export const weeksDialog = () => action(types.OPEN_WEEKS)
export const imagesDialog = () => action(types.OPEN_IMAGES)
export const marksDialog = () => action(types.OPEN_MARKS)
export const stylesheetsDialog = () => action(types.OPEN_STYLESHEET)
